import { action } from 'satcheljs/lib/legacy';
export default action('updateQueryString')(function updateQueryString(recipientWell, queryString) {
    recipientWell.queryString = queryString;
});
//# sourceMappingURL=updateQueryString.js.map